export { createSvgIcon as default } from '@material-ui/core/utils';